import ReactInputMask from "react-input-mask";

import styled, { css } from "styled-components";

// variant "light" (Admin) deixa o campo claro (fundo branco + texto preto); o
// padrão (área comum) mantém fundo escuro + texto branco.
const backgroundColor = ({ theme, variant }) => {
  if (variant === "light") return theme.colors.neutral.white;
  return theme.colors.neutral.cinza900;
};

const disabledBackgroundColor = ({ theme }) => {
  return theme.colors.neutral.cinza900;
};

const placeHolderColor = ({ theme }) => {
  return theme.colors.neutral.cinza300;
};

const padding = () => {
  return "8px 12px";
};

const fontSize = ({ size }) => {
  switch (size) {
    case "xs":
      return "12px";
    case "sm":
      return "14px";
    case "lg":
      return "20px";

    case "md":
    default:
      return "16px";
  }
};

const outline = ({ state, theme }) => {
  switch (state) {
    case "success":
      return `1.5px solid ${theme.colors.feedbackState.success.default}`;
    case "warning":
      return `1.5px solid ${theme.colors.feedbackState.warning.default}`;
    case "error":
      return `1.5px solid ${theme.colors.feedbackState.critical.default}`;

    default:
      return `1px solid ${theme.colors.neutral.gray4}`;
  }
};

const focusBorderColor = ({ theme }) => {
  return theme.colors.primary.prim200;
};

const color = ({ disabled, theme, variant }) => {
  // Campo desabilitado (somente leitura): manter legível em cada tema. Na área
  // admin (fundo branco), texto escuro (cinza600); na área comum (fundo escuro),
  // texto claro (cinza100) para facilitar a leitura.
  if (disabled)
    return variant === "light"
      ? theme.colors.neutral.cinza600
      : theme.colors.neutral.cinza100;

  if (variant === "light") return theme.colors.neutral.cinza900;

  return theme.colors.neutral.white;
};

export const Wrapper = styled.div`
  grid-area: ${({ gridArea }) => gridArea};
  margin: ${({ margin }) => margin}px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 8px;
  width: ${({ width }) => width || "100%"};
  border: none;
  color: ${color};
`;

export const Label = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 4px;
  font-size: ${fontSize};
  font-weight: ${({ theme }) => theme.font.weight.medium};
  line-height: 20px;
  letter-spacing: 0.02em;
  text-align: left;
  color: ${({ theme }) => theme.colors.neutral.white};
  font-family: ${({ theme }) => theme.font.fontFamily};
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  /* height: 100%; */
  width: 100%;
  outline: ${outline};
  background-color: ${backgroundColor};
  /* border-radius: 4px; */
  /* border: 1px solid ${({ theme }) => theme.colors.neutral.cinza800}; */

  /* &:focus-within {
    outline: 1.5px solid ${focusBorderColor};
  } */

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
      background-color: ${disabledBackgroundColor};
    `}
`;

export const RequiredDot = styled.div`
  margin: 2px 0;
  height: 4px;
  width: 4px;
  border-radius: 50%;
  background-color: ${({ theme }) =>
    theme.colors.feedbackState.critical.default};
`;

export const MaskedInputStyleStructure = styled(ReactInputMask)`
  padding: ${padding};
  background-color: ${backgroundColor};
  font-family: ${({ theme }) => theme.font.fontFamily};
  font-size: ${fontSize};
  border: none;
  /* border-radius: 4px; */
  width: 100%;
  &:focus {
    outline: none;
  }

  color: ${color};

  &:disabled {
    cursor: not-allowed;
    background-color: ${disabledBackgroundColor};
    height: 100%;
  }

  &::placeholder {
    color: ${placeHolderColor};
  }
`;

export const InputStylesStructure = styled.input`
  padding: ${padding};
  background-color: ${backgroundColor};
  font-size: ${fontSize};
  border: none;
  color: ${color};
  width: 100%;

  &:focus {
    outline: none;
  }

  &:disabled {
    cursor: not-allowed;
    background-color: ${disabledBackgroundColor};
    height: 100%;
  }

  &::placeholder {
    color: ${placeHolderColor};
  }
`;
